import * as React from 'react';

import * as microsoftTeams from "@microsoft/teams-js";
import deserializeHash from '../../utils/tokenutil';
const LoginSuccess = () => {
    React.useEffect(() => {
        const hash = window.location.hash.replace("#", '');
        const data = deserializeHash(hash)
        if(data.access_token) {
            microsoftTeams.authentication.notifySuccess(data.access_token);
        } else {
            microsoftTeams.authentication.notifyFailure("unknown error");
        }

    })
    return (
        <>
           <div>Prpgress</div>

        </>
    )
};

export default LoginSuccess;
